<div class="content-wrapper">
  <div class="w-100">
    <h1 class="head1">My Profile</h1>
  </div>
  <div class="row">
    <div class="col-md-6 mb-3">
      <div class="card shadow-sm p-3">
        <h5 class="font-15p mb-3">Account Information</h5>
        <form [formGroup]="profileForm" (ngSubmit)="onSubmit()">
          <div class="mb-2 row">
            <label class="col-form-label col-md-3"
              >User Name<span class="text-danger">*</span></label
            >
            <div class="col-md-9">
              <input
                formControlName="username"
                type="text"
                class="form-control"
                required
              />
              <div
                *ngIf="
                  getControl('username')?.invalid &&
                  getControl('username')?.touched
                "
                class="text-danger text-center m-0"
              >
                <ng-container
                  *ngIf="getControl('username')?.errors?.['required']"
                >
                  User Name is required.
                </ng-container>
                <ng-container
                  *ngIf="getControl('username')?.errors?.['whitespace'] && !getControl('username')?.errors?.['required']"
                >
                  User Name can't be empty.
                </ng-container>
              </div>
            </div>
          </div>

          <div class="mb-2 row">
            <label class="col-form-label col-md-3"
              >Email ID<span class="text-danger">*</span></label
            >
            <div class="col-md-9">
              <input
                formControlName="email"
                type="email"
                class="form-control"
              />
              <p
                *ngIf="getControl('email')?.touched"
                class="text-danger text-center m-0"
              >
                <ng-container *ngIf="getControl('email')?.errors?.['required']">
                  Email is required
                </ng-container>
                <ng-container
                  *ngIf="getControl('email')?.errors?.['invalidEmail'] && !getControl('email')?.errors?.['required']"
                >
                  Invalid email format
                </ng-container>
              </p>
            </div>
          </div>

          <div class="mb-2 row">
            <label class="col-form-label col-md-3">&nbsp;</label>
            <div class="col-md-9">
              <img
                [src]="
                  imagePreview
                    ? imagePreview
                    : '../../../assets/images/user-lg.jpg'
                "
                class="rounded-circle img-fluid"
                style="width: 50px; height: auto"
                alt=""
              />
            </div>
          </div>

          <div class="mb-2 row">
            <label class="col-form-label col-md-3"
              >Profile Image<span class="text-danger">*</span></label
            >
            <div class="col-md-9">
              <div class="d-flex">
                <input
                  type="text"
                  class="form-control me-2"
                  [value]="profileImangeName || 'No file chosen'"
                  readonly
                />
                <div class="custom-input-file">
                  <label
                    for="fileInput"
                    class="file-input-label btn btn-primary-sa"
                    >Browse</label
                  >
                  <input
                    type="file"
                    class="file-input"
                    id="fileInput"
                    (change)="onFileChange($event)"
                  />
                </div>
              </div>
              <p
                *ngIf="getControl('profileImage')?.touched"
                class="text-danger text-center m-0"
              >
                <ng-container
                  *ngIf="getControl('profileImage')?.hasError('required')"
                >
                  Profile Image is required
                </ng-container>
              </p>
              <p
                *ngIf="
                  !getControl('profileImage')?.hasError('required') && fileError
                "
                class="text-danger text-center m-0"
              >
                {{ fileError }}
              </p>
            </div>
          </div>

          <div class="mb-2 row">
            <label class="col-form-label col-md-3"
              >Password<span class="text-danger">*</span></label
            >
            <div class="col-md-9">
              <div class="d-flex">
                <input
                  formControlName="password"
                  type="text"
                  class="form-control me-2"
                  value="**********"
                />
                <button
                  type="button"
                  class="btn btn-primary-sa text-nowrap"
                  data-bs-toggle="modal"
                  data-bs-target="#changePasswordModal"
                >
                  Change
                </button>
              </div>
            </div>
          </div>

          <h5 class="font-15p my-4">Personal Details</h5>
          <div class="mb-2 row">
            <label class="col-form-label col-md-3"
              >First Name<span class="text-danger">*</span></label
            >
            <div class="col-md-9">
              <input
                formControlName="firstName"
                type="text"
                class="form-control"
                required
              />
              <div
                *ngIf="
                  getControl('firstName')?.invalid &&
                  getControl('firstName')?.touched
                "
                class="text-danger text-center m-0"
              >
                <ng-container
                  *ngIf="getControl('firstName')?.errors?.['required']"
                >
                  First Name is required.
                </ng-container>
                <ng-container
                  *ngIf="getControl('firstName')?.errors?.['whitespace'] && !getControl('firstName')?.errors?.['required']"
                >
                  First Name can't be empty.
                </ng-container>
              </div>
            </div>
          </div>

          <div class="mb-2 row">
            <label class="col-form-label col-md-3"
              >Last Name<span class="text-danger">*</span></label
            >
            <div class="col-md-9">
              <input
                formControlName="lastName"
                type="text"
                class="form-control"
                required
              />
              <div
                *ngIf="
                  getControl('lastName')?.invalid &&
                  getControl('lastName')?.touched
                "
                class="text-danger text-center m-0"
              >
                <ng-container
                  *ngIf="getControl('lastName')?.errors?.['required']"
                >
                  Last Name is required.
                </ng-container>
                <ng-container
                  *ngIf="getControl('lastName')?.errors?.['whitespace'] && !getControl('lastName')?.errors?.['required']"
                >
                  Last Name can't be empty.
                </ng-container>
              </div>
            </div>
          </div>

          <div class="mb-2 row">
            <label class="col-form-label col-md-3"
              >Date of Birth<span class="text-danger">*</span></label
            >
            <div class="col-md-9">
              <input
                type="text"
                class="form-control"
                bsDatepicker
                [bsConfig]="datePickerConfig"
                formControlName="dob"
                required
                [readonly]="isDateSelected"
                (bsValueChange)="onDateSelected()"
              />
              <div
                *ngIf="
                  profileForm.get('dob')?.invalid &&
                  profileForm.get('dob')?.touched
                "
                class="text-danger text-center m-0"
              >
                Date of Birth is required.
              </div>
              <div
                *ngIf="profileForm.get('dob')?.touched && profileForm.get('dob')?.errors?.['futureDate']"
                class="text-danger"
              >
                Date of Birth cannot be a future date.
              </div>
            </div>
          </div>

          <div class="mb-2 row">
            <label class="col-form-label col-md-3"
              >Gender<span class="text-danger">*</span></label
            >
            <div class="col-md-9">
              <select formControlName="gender" class="form-select" required>
                <option value="">Select Gender</option>
                <option value="female">Female</option>
                <option value="male">Male</option>
                <option value="other">Others</option>
              </select>
              <div
                *ngIf="
                  profileForm.get('gender')?.invalid &&
                  profileForm.get('gender')?.touched
                "
                class="text-danger text-center m-0"
              >
                Gender is required.
              </div>
            </div>
          </div>
          <div class="mb-2 row">
            <label class="col-form-label col-md-3"
              >Phone Number<span class="text-danger">*</span></label
            >
            <div class="col-md-3">
              <select class="form-control" formControlName="countryCode">
                <option
                  *ngFor="let country of countryCodes"
                  [value]="country.dial_code"
                >
                  {{ country.name }} ({{ country.dial_code }})
                </option>
              </select>
              <p
                *ngIf="
                  getControl('countryCode')?.invalid &&
                  getControl('countryCode')?.touched
                "
                class="text-danger m-0"
              >
                Please select country Code.
              </p>
            </div>

            <div class="col-md-6">
              <input
                type="text"
                class="form-control"
                formControlName="ConsumerPhone"
              />
              <p
                *ngIf="
                  getControl('ConsumerPhone')?.invalid &&
                  getControl('ConsumerPhone')?.touched
                "
                class="text-danger m-0"
              >
                Phone number is required and should be 10 digits.
              </p>
            </div>
          </div>
          <div class="mb-4 row">
            <label class="col-form-label col-md-3"
              >Contact Info<span class="text-danger">*</span></label
            >
            <div class="col-md-9">
              <textarea
                formControlName="contactInfo"
                class="form-control"
                required
              ></textarea>
              <div
                *ngIf="
                  profileForm.get('contactInfo')?.invalid &&
                  profileForm.get('contactInfo')?.touched
                "
                class="text-danger text-center m-0"
              >
                Contact Info is required.
              </div>
            </div>
          </div>

          <div class="mb-2 row">
            <label class="col-form-label col-md-3">&nbsp;</label>
            <div class="col-md-9 text-end">
              <button
                type="button"
                class="btn btn-secondary ms-2 mb-2"
                (click)="oncancel()"
              >
                Cancel
              </button>
              <button class="btn btn-primary-sa ms-2 mb-2">Submit</button>
            </div>
          </div>
        </form>
        <div
          class="modal fade"
          id="changePasswordModal"
          tabindex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog">
            <div class="modal-content">
              <form
                [formGroup]="passwordForm"
                (ngSubmit)="submitPasswordChange()"
              >
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">
                    Change Password
                  </h5>
                  <button
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div class="modal-body">
                  <div class="mb-2">
                    <label class="col-form-label">Old Password</label>
                    <input
                      type="password"
                      class="form-control"
                      type="password"
                      formControlName="oldPassword"
                      placeholder="Enter old password"
                      required
                    />
                    <div
                      *ngIf="
                        getControlForm('oldPassword')?.invalid &&
                        getControlForm('oldPassword')?.touched
                      "
                      class="text-danger"
                    >
                      Old password is required.
                    </div>
                  </div>
                  <div class="mb-2">
                    <label class="col-form-label">New Password</label>
                    <input
                      type="password"
                      class="form-control"
                      type="password"
                      formControlName="newPassword"
                      placeholder="Enter new password"
                      required
                    />

                    <div
                      *ngIf="
                        getControlForm('newPassword')?.hasError('required') &&
                        getControlForm('newPassword')?.touched
                      "
                      class="text-danger"
                    >
                      New password is required.
                    </div>
                    <p
                      *ngIf="getControlForm('newPassword')?.errors?.['pattern'] && getControlForm('newPassword')?.touched"
                      class="text-danger text-center m-0"
                    >
                      Password must be at least 8 characters long, include 1
                      uppercase letter, 1 lowercase letter, 1 number, and 1
                      special character.
                    </p>
                  </div>
                  <div class="mb-2">
                    <label class="col-form-label">Confirm Password</label>
                    <input
                      type="password"
                      class="form-control"
                      type="password"
                      formControlName="confirmPassword"
                      placeholder="Confirm new password"
                      required
                    />

                    <div
                      *ngIf="
                        getControlForm('confirmPassword')?.hasError(
                          'required'
                        ) && getControlForm('confirmPassword')?.touched
                      "
                      class="text-danger"
                    >
                      Confirm password is required.
                    </div>
                    <div
                      *ngIf="passwordForm.errors?.['passwordMismatch'] && getControlForm('confirmPassword')?.touched"
                      class="text-danger"
                    >
                      Passwords do not match.
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-secondary ms-2"
                    data-bs-dismiss="modal"
                    (click)="cancelPasswordChange()"
                  >
                    Cancel
                  </button>
                  <button type="submit" class="btn btn-primary-sa ms-2">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ng-container *ngIf="isProjectAdmin">
      <div class="col-md-6 mb-3">
        <div class="card shadow-sm p-3" style="min-height: 200px">
          <h5 class="font-15p mb-5">Security token</h5>
          <div class="mb-2 row">
            <div class="col-md-7 pe-0">
              <div
                class="form-control bg-grey border-0 text-danger pt-2 rounded-2"
              >
                {{ token }}
              </div>
            </div>

            <div class="col-md-5 ps-0">
              <ng-container *ngIf="token">
                <button
                  class="btn btn-primary-sa ms-2 mb-2 float-start"
                  (click)="copyToken()"
                >
                  Copy
                </button>
              </ng-container>
              <button
                class="btn btn-primary-sa ms-2 mb-2 float-start"
                (click)="generateToken()"
              >
                Generate
              </button>
            </div>
          </div>
          <div class="mb-2 row">
            <p>{{ expiryInfo }}</p>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
